import { utils } from './_utils.js';
var header = function header() {
  var header = document.getElementById('js-header');
  var hamburger = document.getElementById('js-hamburger');
  var footer = document.getElementById('js-footer');
  var NAV_CLASS = 'is-active';
  var VISIBILITY_CLASS = 'is-hidden';
  var intersectionObserver = function intersectionObserver(rootMargin, callback, target) {
    var observer = new IntersectionObserver(callback, {
      rootMargin: rootMargin,
      threshold: 0
    });
    observer.observe(target);
  };
  var changeHeaderSize = function changeHeaderSize() {
    utils.clearCachedIsMobile();
    if (utils.isMobile) {
      header.classList.remove('is-narrow');
      return;
    }
    header.classList.toggle('is-narrow', window.scrollY > 0);
  };
  var toggleVisibility = function toggleVisibility(entries) {
    if (entries[0].isIntersecting) {
      header.classList.add(VISIBILITY_CLASS);
    } else {
      header.classList.remove(VISIBILITY_CLASS);
    }
  };
  var toggleNav = function toggleNav() {
    hamburger.addEventListener('click', function () {
      var isActive = header.classList.toggle(NAV_CLASS);
      document.body.style.overflow = isActive ? 'hidden' : '';
    });
  };
  intersectionObserver('0%', toggleVisibility, footer);
  toggleNav();
  changeHeaderSize();
  window.addEventListener('scroll', changeHeaderSize);
  window.addEventListener('resize', changeHeaderSize);
};
export default header;